import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import AssignmentSelect from "containers/Forms/Partials/AssignmentSelect";
import Modal from 'containers/Modals/Modal';
import { Button, Icon, translate } from '@haldor/ui';

var SelectAssignment = /*#__PURE__*/function (_Component) {
  _inherits(SelectAssignment, _Component);

  var _super = _createSuper(SelectAssignment);

  function SelectAssignment(props) {
    var _this;

    _classCallCheck(this, SelectAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (event) {
      if (event != null) {
        event.preventDefault();
        event.stopPropagation();
      }

      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectAssignmentForPlan", function (assignment) {
      if (assignment.id == parseInt(assignment.id)) {
        // Haldor assignment
        delete assignment.associatedMatrices;
        delete assignment.courses;
        delete assignment.assessmentId;
        delete assignment.assignmentDocuments;
        delete assignment.attachedFiles;
        delete assignment.containerId;
        delete assignment.documentTemplates;
        delete assignment.origin;
        delete assignment.removeInstructions;
        delete assignment.selectedCourses;
        delete assignment.section;
        delete assignment.plagiarismCheck;
        delete assignment.teacher;
        delete assignment.sectionUrl;
        delete assignment.plans;
        delete assignment.isDeletable;
        delete assignment.locked;
        delete assignment.matrix;
        delete assignment.tasks;
      } else {// MS Teams assignment
      }

      if (_this.props.onPicked != null) {
        _this.props.onPicked(assignment);
      }

      _this.setState({
        modal: false
      });
    });

    _this.state = {
      modal: false
    };
    return _this;
  }

  _createClass(SelectAssignment, [{
    key: "render",
    value: function render() {
      var filterAssignments = [];
      var section = null;

      if (this.props.selectedSections != null && this.props.selectedSections.length > 0) {
        section = this.props.selectedSections[0];
      } else {
        section = this.props.activeSection;
      }

      if (this.props.plan != null && this.props.plan.associatedAssignments != null) {
        filterAssignments = this.props.plan.associatedAssignments.map(function (assignment) {
          return assignment.assignmentId;
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        type: "small editor-block-modal",
        onClose: this.toggleModal,
        title: this.props.translate('Select assignment')
      }, /*#__PURE__*/React.createElement(AssignmentSelect, {
        section: section,
        onSelect: this.selectAssignmentForPlan,
        filterResults: filterAssignments,
        includeAssignmentsWithPlans: true
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Magnify",
        bw: true
      }), this.props.translate('Search assignment')));
    }
  }]);

  return SelectAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    plan: state.planning.active_plan,
    activeSection: state.sections.activeSection,
    selectedSections: state.sections.selected
  };
}

export default connect(mapStateToProps, {})(SelectAssignment);